/**
 * SoftphonePage \u2014 placeholder route element.
 *
 * The actual <Softphone> component is mounted persistently inside
 * PortalShell so that an active call survives route changes. This route
 * exists so that /softphone resolves to a valid React Router endpoint;
 * the shell decides whether to show or hide the softphone based on the
 * current path.
 */
import React from 'react';

export default function SoftphonePage() {
  // Render nothing; PortalShell takes over for /softphone.
  return null;
}
